// Tiny Web Audio synth for playful game sound effects (no asset loading).
let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, start, dur, type = "sine", vol = 0.25, slideTo = null) {
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

export const sfx = {
  unlock() {
    getCtx();
  },
  pop() {
    tone(500, 0, 0.12, "triangle", 0.3, 900);
  },
  tap() {
    tone(420, 0, 0.08, "sine", 0.2, 520);
  },
  correct() {
    tone(523, 0, 0.12, "triangle", 0.3);
    tone(659, 0.1, 0.12, "triangle", 0.3);
    tone(784, 0.2, 0.18, "triangle", 0.3);
  },
  wrong() {
    tone(200, 0, 0.18, "sawtooth", 0.18, 120);
  },
  burp() {
    tone(140, 0, 0.35, "sawtooth", 0.3, 70);
  },
  chomp() {
    tone(300, 0, 0.09, "square", 0.25, 160);
    tone(240, 0.09, 0.09, "square", 0.25, 120);
  },
  magic() {
    tone(660, 0, 0.1, "sine", 0.22);
    tone(880, 0.08, 0.1, "sine", 0.22);
    tone(1175, 0.16, 0.18, "sine", 0.22);
  },
  fanfare() {
    tone(523, 0, 0.15, "triangle", 0.3);
    tone(659, 0.14, 0.15, "triangle", 0.3);
    tone(784, 0.28, 0.15, "triangle", 0.3);
    tone(1046, 0.42, 0.3, "triangle", 0.3);
  },
  star() {
    tone(880, 0, 0.1, "triangle", 0.25, 1320);
  },
};
